/**
 * The Traverse TLS port: the one place its limits and default are set. The backend mirrors them in
 * apps/infrastructure/config/catalog.py, and sends DEFAULT_TLS_PORT to the pipeline when none is given.
 */
export const MIN_TLS_PORT = 2113
export const MAX_TLS_PORT = 65535
export const DEFAULT_TLS_PORT = 2113
export const TLS_PORT_NOTE = `${DEFAULT_TLS_PORT} is the default port of a new RDS server.`

/** Why a TLS port cannot be used, or null when it can: a whole number from MIN_TLS_PORT to MAX_TLS_PORT. */
export function tlsPortProblem(raw: string): string | null {
  const value = raw.trim()
  if (value === '') return 'TLS port is required.'
  if (!/^\d+$/.test(value)) return `TLS port must be a whole number from ${MIN_TLS_PORT} to ${MAX_TLS_PORT}.`
  const port = Number(value)
  if (port < MIN_TLS_PORT) return `TLS port must be ${MIN_TLS_PORT} or higher.`
  if (port > MAX_TLS_PORT) return `TLS port must be ${MAX_TLS_PORT} or lower.`
  return null
}
